import React from 'react';
import clsx from 'clsx';
import Config from '~/config';
import I18nLink from '~/components/I18nLink';
import { slugs } from '~/utils';
import themeVariables from '~/shared/themeVariables';

const SimilarOtherService = ({
  title,
  collection,
  serviceType,
  dataID,
  lng,
  t,
  keyword,
}) => {
  const FIXED_NUMBERS_IMAGE = 5;
  const isSilhouette = serviceType === Config.getServiceTypes().SILHOUETTE_AC;
  const isPhotoAC = serviceType === Config.getServiceTypes().PHOTO_AC;

  const renderSimilarUrl = (item) => {
    let url = '';
    const photoTitle = Config.getTitleByLanguage(item.title, lng);

    url = `/${Config.detailPagePath[serviceType]}/${item.id}`;
    if (photoTitle) {
      const slugTitle = slugs.makeSlug(photoTitle, { lang: lng });
      url = `/${Config.detailPagePath[serviceType]}/${item.id}/${slugTitle}`;
    }

    return url;
  };

  return (
    <>
      <div className="similar-other-service-wrapper">
        <h2>{title}</h2>
        <div className="similar-other-images">
          {collection
            .slice(
              0,
              FIXED_NUMBERS_IMAGE > collection.length
                ? collection.length - 1
                : FIXED_NUMBERS_IMAGE - 1,
            )
            .map((item, index) => (
              <I18nLink
                prefetch={false}
                host={Config.getSiteURL(serviceType)}
                href={renderSimilarUrl(item, lng)}
                key={index}
              >
                <a
                  target="_blank"
                  rel="noreferrer"
                  className={clsx('item-images', {
                    'similar-silhouette': isSilhouette,
                    'similar-photo': isPhotoAC,
                  })}
                >
                  <img
                    alt={item.title.name_en}
                    data-src={item.thumbnail}
                    className="lazyload"
                  />
                </a>
              </I18nLink>
            ))}
          <I18nLink
            prefetch={false}
            host={Config.getSiteURL(serviceType)}
            href={`/search-result/similar/${dataID}?service_type_for_similar=${Config.serviceType}&keyword=${keyword}`}
          >
            <a
              target="_blank"
              rel="noreferrer"
              className={clsx('last-similar-image item-images', {
                'similar-silhouette': isSilhouette,
                'similar-photo': isPhotoAC,
              })}
            >
              <img
                alt={collection[collection.length - 1].title?.name_en}
                data-src={collection[collection.length - 1].thumbnail}
                className="lazyload"
              />
              <span className="view-all-image">{t('view_all')}</span>
            </a>
          </I18nLink>
        </div>
      </div>
      <style jsx>
        {`
          .similar-other-service-wrapper {
            margin: 16px 0;
          }
          h2 {
            font-weight: 600;
            font-size: 20px;
            line-height: 23px;
            color: #170507;
            margin: 24px 0;
          }
          .similar-other-images {
            display: grid;
            grid-column: 1 / 5;
            grid-template-columns: repeat(5, 1fr);
            width: 100%;
            grid-gap: 8px;
          }
          .item-images:hover {
            opacity: 0.9;
          }
          .similar-silhouette,
          .similar-silhouette:hover,
          .similar-silhouette.last-similar-image img {
            mix-blend-mode: hard-light;
          }
          .last-similar-image {
            position: relative;
          }
          .last-similar-image,
          .item-images {
            height: 160px;
            width: 100%;
            border: 1px solid #7a7a7a;
            border-radius: 4px;
            background-color: #ffffff;
            position: relative;
            border-radius: 4px;
            overflow: hidden;
          }
          .item-images img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            background-color: #ffffff;
          }
          .similar-silhouette {
            border: 1px solid #5d5d5d;
          }
          .similar-silhouette img {
            object-fit: contain;
          }
          .view-all-image {
            top: 0;
            left: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: linear-gradient(
              0deg,
              rgba(0, 0, 0, 0.68),
              rgba(0, 0, 0, 0.68)
            );
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
            color: #ffffff;
          }
          @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
            .similar-other-images {
              position: relative;
              overflow-x: scroll;
              display: flex;
              -webkit-overflow-scrolling: touch;
              scroll-behavior: smooth;
              -webkit-scroll-snap-points-x: repeat(240px);
              -ms-scroll-snap-points-x: repeat(240px);
              scroll-snap-points-x: repeat(240px);
              -webkit-scroll-snap-type: mandatory;
              -ms-scroll-snap-type: mandatory;
              scroll-snap-type: mandatory;
            }
            .last-similar-image,
            .item-images {
              width: 240px;
              flex-shrink: 0;
            }
            h2 {
              font-size: 18px;
            }
          }
        `}
      </style>
    </>
  );
};

export default SimilarOtherService;
